export default __webpack_public_path__ + "static/media/troya.e5ddd63c.jpg";